import React from 'react';

const FeedContext = React.createContext();

export function useFeedContext() {
  return React.useContext(FeedContext);
}

export default FeedContext;
